// extracted by mini-css-extract-plugin
export default {"header":"FormMuseumEventVisitsEditorItem_header__sboe7","title":"FormMuseumEventVisitsEditorItem_title__zsEhy"};